import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function RefundPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-[#94A3B8]">
      <div className="max-w-3xl mx-auto px-6 py-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#38BDF8] hover:text-white transition-colors mb-10"
        >
          ← Back to Home
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Refund Policy</h1>
        <p className="text-sm text-[#64748B] mb-10">Last updated: May 29, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-semibold text-base mb-2">Overview</h2>
            <p>
              Tyo Solution offers credit-based API services. We want you to be satisfied with your
              purchase. Please read this Refund Policy carefully before purchasing credits.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">1. Credit Purchases</h2>
            <p>
              Credits are purchased as a one-time, non-recurring payment. Once credits are added to
              your account and have been used to process requests, they are non-refundable. Credits
              that have not been consumed remain valid and associated with your account indefinitely
              unless otherwise stated.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">2. Eligibility for Refund</h2>
            <p className="mb-2">
              You may request a full refund within <strong className="text-white">7 days</strong> of
              purchase if:
            </p>
            <ul className="list-disc list-inside space-y-1 text-[#64748B]">
              <li>No credits have been consumed from the purchased package.</li>
              <li>You experienced a technical issue on our end that prevented you from using the service.</li>
              <li>You were charged incorrectly or more than once for the same order.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">3. Non-Refundable Cases</h2>
            <ul className="list-disc list-inside space-y-1 text-[#64748B]">
              <li>Credits that have been partially or fully consumed.</li>
              <li>Requests made more than 7 days after the purchase date.</li>
              <li>Dissatisfaction due to output quality after successful API processing (results depend on input quality).</li>
              <li>Accounts terminated due to violation of our Terms of Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">4. How to Request a Refund</h2>
            <p>
              To request a refund, email us at{" "}
              <a href="mailto:hi@tyosolution.com" className="text-[#38BDF8] hover:underline">
                hi@tyosolution.com
              </a>{" "}
              with the subject line <strong className="text-white">"Refund Request"</strong> and
              include:
            </p>
            <ul className="list-disc list-inside space-y-1 mt-2 text-[#64748B]">
              <li>Your registered email address.</li>
              <li>The order/transaction ID (from your Paddle receipt).</li>
              <li>A brief description of the reason for the refund request.</li>
            </ul>
            <p className="mt-2">
              We will review your request and respond within <strong className="text-white">3 business days</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">5. Refund Processing</h2>
            <p>
              Approved refunds are processed through our payment provider (Paddle). Refunds are
              credited to the original payment method within 5–10 business days depending on your
              bank or card issuer.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">6. Service Disruptions</h2>
            <p>
              If a service outage or bug on our end caused credits to be consumed without delivering
              a result, we will credit those credits back to your account automatically or upon
              request. This is handled separately from the refund process.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">7. Contact</h2>
            <p>
              For refund inquiries or disputes, contact us at{" "}
              <a href="mailto:hi@tyosolution.com" className="text-[#38BDF8] hover:underline">
                hi@tyosolution.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
